export default {
    data() {
        let defaultDate = new Date('2017-01-01')
        let today = new Date()
        // today.setHours(0, 0, 0, 0)
        let yesterday = new Date()
        yesterday.setDate(today.getDate() - 1)
        // yesterday.setHours(0, 0, 0, 0);
        let weekAgo = new Date()
        weekAgo.setDate(today.getDate() - 7)
        // weekAgo.setHours(0, 0, 0, 0);
        let day_30 = new Date()
        day_30.setDate(today.getDate() - 30)
        // day_30.setHours(0, 0, 0, 0);
        let thisMonth = new Date(today.getFullYear(), today.getMonth(), 1)
        // thisMonth.setHours(0, 0, 0, 0);
        let day_365 = new Date()
        day_365.setDate(today.getDate() - 365)
        let monthAgo = new Date()
        monthAgo.setMonth(today.getMonth() - 1)
        // day_365.setHours(0, 0, 0, 0);
        return {
            defaultDate: defaultDate,
            today: today,
            yesterday: yesterday,
            monthAgo: monthAgo,
            thisMonth: thisMonth,
            weekAgo: weekAgo,
            day_30: day_30,
            day_365: day_365,
        }
    },
    methods: {
        dateToString: function(date) {
            let month = date.getMonth() + 1
            month = month > 9 ? month : '0'+ month
            let day = date.getDate() > 9 ? date.getDate() : '0'+ date.getDate()

            return  date.getFullYear() +'-'+ month +'-'+ day
        },
        nFormat: function (number, afterDot = 0) {
            if (number === null || number === '') {
                return 'н/д';
            }
            number = Number(number);
            afterDot = number > 10 ? 0 : afterDot;
            return new Intl.NumberFormat('ru-RU').format(Number((number).toFixed(afterDot)));
        },
        sFormat: function (string) {
            if (string === null || string === '') {
                return 'н/д'
            }
            if (string === '') {
                return '--'
            }

            return string
        },
        initPageSize: function(topPadding = 250) {
            let winHeight = window.innerHeight
            winHeight = Math.round((winHeight - topPadding) / 25)
            winHeight = winHeight <= 0 ? 1 : winHeight

            return winHeight
        },
        getOnlyNames: function (date) {
            if (date == null || date[0] == null) {
                return []
            }
            if (date[0] == 'Все') {
                return date
            }
            let nameList = []
            for (let key in date) {
                nameList.push(date[key].name)
            }
            return nameList
        },
        deepFreeze: function (obj) {
            var propNames = Object.getOwnPropertyNames(obj);
            propNames.forEach(function(name) {
                var prop = obj[name];
                if (typeof prop == 'object' && prop !== null)
                    this.deepFreeze(prop);
            });

            return Object.freeze(obj);
        },
        createParamsUrl: function (params) {
            let urlParams = [];
            for (let prop in params) {
                if (params[prop] !== false && params[prop] !== '') {
                    urlParams.push(prop +'='+ encodeURIComponent(params[prop]));
                }
            }
            return '?'+ urlParams.join('&');
        },
        isTranslation: function (fieldName, translationList) {
            if (fieldName.indexOf('-') === -1) {
                return false
            }
            fieldName = fieldName.split('-')
            if (translationList[fieldName[0]] === undefined) {
                return false
            }

            return (
                translationList[fieldName[0]] != null
                && Array.isArray(translationList[fieldName[0]])
                && translationList[fieldName[0]].includes(fieldName[1])
            )

        },
        translationBacklight: function (fieldName, item, value) {
            if (fieldName.indexOf('category') !== -1 ) {
                let parts = fieldName.split('-')
                let lang = parts[1].replace('_name', '')
                let formatCategoryList = []
                for (let key in item.categoryAsArray) {
                    let val = item.categoryAsArray[key]
                    formatCategoryList.push({
                        value: val.name[lang],
                        isTranslated: val.translations.includes(lang)
                    })
                }

                return formatCategoryList
            }

            return [{
                value: value,
                isTranslated: this.isTranslation(fieldName, item.translations)
            }]
        },
        chunkArray: function(arr, len) {
            const chunks = [];
            for (let i = 0; i < arr.length; i += len) {
                chunks.push(arr.slice(i, i + len));
            }

            return chunks;
        }
    }
}